import { render, staticRenderFns } from "./baseTableGroup.vue?vue&type=template&id=7892f504&scoped=true"
import script from "./baseTableGroup.vue?vue&type=script&lang=js"
export * from "./baseTableGroup.vue?vue&type=script&lang=js"
import style0 from "./baseTableGroup.vue?vue&type=style&index=0&id=7892f504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7892f504",
  null
  
)

export default component.exports